"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point = Point;
/**
 * Возвращает объект представляющий точку в двухмерном пространстве.
 * @param x Координата по оси X.
 * @param y Координата по оси Y.
 * @return Объект представляющий точку.
 */
function Point(x = 0, y = 0) {
    return { x, y };
}
// @todo перенести в math?
//# sourceMappingURL=point.js.map